import { render, staticRenderFns } from "./platformAnnouncement.vue?vue&type=template&id=774b65ed&scoped=true"
import script from "./platformAnnouncement.vue?vue&type=script&lang=js"
export * from "./platformAnnouncement.vue?vue&type=script&lang=js"
import style0 from "./platformAnnouncement.vue?vue&type=style&index=0&id=774b65ed&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774b65ed",
  null
  
)

export default component.exports